import { RouteTypes } from 'consts';
import Header from 'containers/Header';
import Table from 'containers/Table';
import { useRef } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { RfUiBreadcrumbs, RfUiModal } from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  getCursos,
  getCursosCount,
  getExcelCursos,
  setCursos,
  setCursosCount,
  setEstadoCurso,
} from 'store/cursos/actions';
import {
  makeSelectCursos,
  makeSelectCursosCount,
  makeSelectSociedadesCursosParsed,
} from 'store/cursos/selectors';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import { hasAccess } from 'utils/listUtils';
import { parseDate } from 'utils/parsePractices';
import { userProfile } from 'utils/profilesIndex';
import { CursosFilter } from './CoursesFilter/CoursesFilter';
import './Course.scss';
import { estados } from 'utils/estados';
import { useList } from 'hooks/list';
import { getCellClassName } from 'utils/dateTimeUtils';
import {
  getTodayFinishDate,
  getTodayMinusOneYearStartDate,
} from 'utils/dates-validators';
import { setLoading, setModalDraftType, setMsgSubmit } from 'store/app/actions';
import { makeSelectModalDraftType, makeSelectMsgSubmit } from 'store/app/selectors';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  access_token: makeSelectTokenAccessToken(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  cursos: makeSelectCursos(),
  cursosCount: makeSelectCursosCount(),
  sociedades: makeSelectSociedadesCursosParsed(),
  profileSelected: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
} as any);

export const links = [
  {
    label: 'Listado de cursos',
    link: '#',
    textHelp: 'Listado de cursos',
    active: true,
  },
];

const initFilter = {
  elemInicio: 0,
  // elemFin: 10, // Algunas peticiones cambian el nombre del parámetro
  elemFinal: 10,
  orden: '',
  ascDesc: '',
  fechaInicio: getTodayMinusOneYearStartDate(),
  fechaFin: getTodayFinishDate(),
  sociedades: '',
  estados: 'IN',
  cursos: '',
  provincias: '',
};

const options =
  '[{"label": "Fecha inicio de menor a mayor","value": {"order":"FECHA_INI_CURSO","ascDesc": "asc"},"active": "true"},{"label": "Fecha inicio de mayor a menor","value": {"order":"FECHA_INI_CURSO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de mayor a menor","value": {"order":"FECHA_FIN_CURSO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de menor a mayor","value": {"order":"FECHA_FIN_CURSO","ascDesc": "asc"},"active": "false"}]';

const Courses = (): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    access_token,
    msgSubmit,
    modalDraftType,
    cursos,
    profileActive,
    cursosCount,
    sociedades,
    profileSelected,
  } = useSelector<any, any>(selectors);

  const {
    filterRef,
    data,
    setData,
    headers,
    setHeaders,
    handleFilterTable,
    handleFilterChange,
  } = useList(
    { ...initFilter },
    [],
    {
      action: (filter) => {
        return dispatch(getCursos(filter));
      },
      headerToAPIMap: {
        Desde: 'FECHA_INI_CURSO',
        Hasta: 'FECHA_FIN_CURSO',
      },
    },
    (filter) => {
      setData([]); // Hay que resetar el listado porque los selectores dentro de la tabla no se actualizan, revisar el componente
      dispatch(setCursosCount(-1));

      dispatch(getCursos(filter));
      dispatch(getCursosCount(filter));
    },
    async () => {
      dispatch(setLoading(true));
      await new Promise(resolve => setTimeout(resolve, 90));
      dispatch(setLoading(false));
    }
  );

  const courseToChangeState = useRef<{ estadoId: string; cursoId: number }>();

  const [modalOkType, setModalOkType] = useState('');
  const [modalOkMessage] = useState('');
  const [modalCerradoType, setModalCerradoType] = useState('');

  const [statusBefore, setStatusBefore]: any[] = useState([]);

  const handleExportExcel = () => {
    dispatch(
      getExcelCursos({
        filter: { ...filterRef.current },
        excelConfig: {
          literals: headers,
          profile: profileActive,
        },
      })
    );
  };

  const handleCellSelect = (e) => {
      if (profileActive?.ID_PERFIL == userProfile.supervisor || profileActive?.ID_PERFIL == userProfile.visualizador
    ) {
      return;
    }
    dispatch(setLoading(true));
    if (e.detail.id) {
      e.courseid = e.detail.id;
      e.coursedetail = e.detail.detail;
    } else {
      e.courseid = e.id;
      e.coursedetail = e.detail;
    }
    const statusBeforeModify: any = statusBefore.filter(
      (now: any) => now.id === e.courseid
    );
    const statusKey = getStatusKey(e.coursedetail);
    // Si se modifica un curso con estado cerrado debe saltar modal avisando que se hara de manera manual más tarde
    if (statusBeforeModify[0].status === 'CE') {
      courseToChangeState.current = {
        estadoId: statusKey,
        cursoId: e.courseid,
      };
      openModalCerrado();
      return;
    }
    if (statusKey === 'CE') {
      courseToChangeState.current = {
        estadoId: statusKey,
        cursoId: e.courseid,
      };
      setData([]);
      dispatch(
        setEstadoCurso({
          params: courseToChangeState.current,
          filter: { ...filterRef.current },
          cursosCierre: false,
        })
      );
      return;
    }
    // Hay que resetar el listado porque los selectores dentro de la tabla no se actualizan, revisar el componente
    dispatch(
      setEstadoCurso({
        params: {
          // estadoId: e.estado,
          // cursoId: e.curso.ID_CURSO,
          estadoId: statusKey,
          cursoId: e.courseid,
        },
        filter: { ...filterRef.current },
        cursosCierre: false,
      })
    );
    setData([]);
  };

  const getStatusKey = (status: string): string => {
    return Object.keys(estados).find((key) => estados[key] === status)!;
  };

  const closeModalOk = () => {
    setModalOkType('');
  };

  const openModalCerrado = () => {
    setModalCerradoType('confirm');
  };

  const closeModalCerrado = () => {
    setModalCerradoType('');

    // Empty data and fill it again to reset selectors selected value
    const cursosCopy = [...cursos];

    dispatch(setCursos([]));

    setTimeout(() => {
      // force table re-render because selects don't reset
      dispatch(setCursos([...cursosCopy]));
    });
    dispatch(setLoading(false));
  };

  const confirmModalCerrado = () => {
    if (
      profileActive?.ID_PERFIL == userProfile.supervisor ||
      profileActive?.ID_PERFIL == userProfile.visualizador
    ) {
    return;
  }
    setData([]);

    dispatch(
      setEstadoCurso({
        params: courseToChangeState.current,
        filter: { ...filterRef.current },
        cursosCierre: false,
      })
    );
  };

  const redirect = (e: any) => {
    history.push(e.detail);
  };

  useEffect(() => {
    const hasSociedades = JSON.parse(sociedades).length;

    if (profileActive && hasSociedades) {
      dispatch(getCursos(filterRef.current));
      dispatch(getCursosCount(filterRef.current));
    }
  }, [profileActive, sociedades]);

  useEffect(() => {
    if (!profileActive) {
      return;
    }

    const commonsFields = [
      { text: 'Código' },
      { text: 'Nombre' },
      {
        text: 'Desde',
        orderBy: 'asc',
        ariaLabelIcon: 'Icono de ordenar',
      },
      {
        text: 'Hasta',
        orderBy: 'asc',
        ariaLabelIcon: 'Icono de ordenar',
      },
      { text: 'Sociedad' },
    ];

    const additionalFields = [
      { text: 'Provincia' },
      { text: 'Modificación' },
      { text: 'Usuario modificación' },
      { text: 'Cambio estado' },
    ];

    const estadoField = [{ text: 'Estado' }];

    if (profileActive) {
      if (
        profileActive.ID_PERFIL === userProfile.formador ||
        profileActive.ID_PERFIL === userProfile.gestor ||
        profileActive.ID_PERFIL === userProfile.administrador ||
        profileActive.ID_PERFIL === userProfile.supervisor ||
        profileActive.ID_PERFIL === userProfile.visualizador
      ) {
        setHeaders([...commonsFields, ...additionalFields, ...estadoField]);
      } else {
        setHeaders([...commonsFields, ...estadoField]);
      }
    }
  }, [profileActive]);

  const getEstadoSelectOption = (codigo: string, curso) => {
    return {
      label: estados[codigo],
      value: estados[codigo],
      active: (curso.ID_ESTADO === codigo).toString(),
      className: getCellClassName(curso, profileActive),
    };
  };

  const statusLoop = () => {
    const status: any = [];
    cursos.forEach((element) => {
      status.push({ id: element.ID_CURSO, status: element.ID_ESTADO });
    });
    return status;
  };


  const canShowCourseAdditionalFields = () => {
    return (
      profileActive.ID_PERFIL === userProfile.formador ||
      profileActive.ID_PERFIL === userProfile.gestor ||
      profileActive.ID_PERFIL === userProfile.administrador ||
      profileActive.ID_PERFIL === userProfile.supervisor ||
      profileActive.ID_PERFIL === userProfile.visualizador
    );
  };

  const buildCourseAlumnsUrl = (item) =>
    RouteTypes.ALUMNS.replace(':cursoId', item.ID_CURSO).replace(':nombreCurso?', item.NOMBRE_CURSO);

  const buildPracticesAlumnCourseUrl = (item) =>
    RouteTypes.PRACTICES_ALUMN_COURSE.replace(':cursoId?', item.ID_CURSO).replace(':idAlumn?', profileSelected.ID_USUARIO);

  const buildCommonField = (item, canSeeCourseAlumns: boolean) => {

    const urlLink = canSeeCourseAlumns ? buildCourseAlumnsUrl(item) : buildPracticesAlumnCourseUrl(item);
    return [
      {
        text: item.ID_CURSO,
        urlLink,
        // '',
        className: getCellClassName(item, profileActive),
      },
      {
        text: item.NOMBRE_CURSO,
        className: getCellClassName(item, profileActive),
      },
      {
        text: parseDate(item.FECHA_INI_CURSO),
        className: getCellClassName(item, profileActive),
      },
      {
        text: parseDate(item.FECHA_FIN_CURSO),
        className: getCellClassName(item, profileActive),
      },
      {
        text: item.sociedad_parsed,
        className: getCellClassName(item, profileActive),
      },
    ];
  };

  const buildAdditionalFields = (item) => {
    if (!canShowCourseAdditionalFields()) {
      return [];
    }

    return [
      {
        text: item.PROVINCIA_CURSO,
        className: getCellClassName(item, profileActive),
      },
      {
        text: item.FECHA_MODIFICACION
          ? parseDate(item.FECHA_MODIFICACION)
          : '',
        className: getCellClassName(item, profileActive),
      },
      {
        text: item.USUARIO_MOD,
        className: getCellClassName(item, profileActive),
      },
      {
        text: item.FECHA_CAMBIO_EST
          ? parseDate(item.FECHA_CAMBIO_EST)
          : '',
        className: getCellClassName(item, profileActive),
      },
    ];
  };

  const addAdministradorOptions = (accionesPosibles: any[], item, todayMinus15days: Date) => {
    if (!hasAccess(profileActive, [userProfile.administrador])) {
      return;
    }

    accionesPosibles.push(getEstadoSelectOption('PU', item));
    accionesPosibles.push(getEstadoSelectOption('IN', item));
    accionesPosibles.push(getEstadoSelectOption('FI', item));
    accionesPosibles.push(getEstadoSelectOption('RZ', item));
    accionesPosibles.push(getEstadoSelectOption('PE', item));
    accionesPosibles.push(getEstadoSelectOption('AN', item));

    if (
      (item.ID_ESTADO === 'FI' &&
        todayMinus15days.getTime() > item.FECHA_FIN_CURSO) ||
      item.ID_ESTADO === 'CE'
    ) {
      accionesPosibles.push(getEstadoSelectOption('CE', item));
    }
  };

  const addGestorOptions = (accionesPosibles: any[], item, todayMinus15days: Date) => {
    if (!hasAccess(profileActive, [userProfile.gestor])) {
      return;
    }

    if (
      item.ID_ESTADO === 'FI' &&
      todayMinus15days.getTime() > item.FECHA_FIN_CURSO
    ) {
      accionesPosibles.push(getEstadoSelectOption('CE', item));
    }
    accionesPosibles.push(getEstadoSelectOption(item.ID_ESTADO, item));
  };

  const buildAccionesPosibles = (item, todayMinus15days: Date) => {
    const accionesPosibles: any[] = [];

    addAdministradorOptions(accionesPosibles, item, todayMinus15days);
    addGestorOptions(accionesPosibles, item, todayMinus15days);

    return accionesPosibles;
  };

  const buildEstadoField = (item, accionesPosibles: any[]) => {
    return accionesPosibles.length
      ? [
        {
          select: [
            {
              options: accionesPosibles,
              placeholder: '',
              disabled: accionesPosibles.length <= 1 ? true : false,
              withoutOptionsText: false,
              id: item.ID_CURSO,
            },
          ],
          className: getCellClassName(item, profileActive),
        },
      ]
      : [
        {
          text: estados[item.ID_ESTADO],
          className: getCellClassName(item, profileActive),
        },
      ];
  };

  const buildCursoParsed = (item, canSeeCourseAlumns: boolean) => {
    const todayMinus15days = new Date();
    todayMinus15days.setDate(todayMinus15days.getDate() - 15);

    const commonField = buildCommonField(item, canSeeCourseAlumns);
    const additionalFields = buildAdditionalFields(item);
    const accionesPosibles = buildAccionesPosibles(item, todayMinus15days);
    const estadoField = buildEstadoField(item, accionesPosibles);

    return {
      table: [[...commonField, ...additionalFields, ...estadoField]],
    };
  };

  useEffect(() => {
    if (!profileActive) {
      return;
    }

    const canSeeCourseAlumns = hasAccess(profileActive, [
      userProfile.gestor,
      userProfile.administrador,
      userProfile.formador,
      userProfile.supervisor,
      userProfile.visualizador
    ]);

    const cursosParsed = cursos.map((item) =>
      buildCursoParsed(item, canSeeCourseAlumns)
    );

    /** Method by add all status from cursos in array */
    statusLoop();
    setStatusBefore(statusLoop);

    setData(cursosParsed);
  }, [cursos]);

  if (
    !hasAccess(profileActive, [
      userProfile.formador,
      userProfile.gestor,
      userProfile.administrador,
      userProfile.alumno.extBecario,
      userProfile.alumno.extAspirante,
      userProfile.alumno.extMaquinista,
      userProfile.alumno.intBecario,
      userProfile.alumno.intMaquinista,
      userProfile.supervisor,
      userProfile.visualizador,
    ])
  ) {
    return <Redirect to={RouteTypes.HOME} push />;
  }

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  return (
    <div className="courses-container">
      <Header />
      <div className="rf-layout-table rf-practice-list">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">Listado de cursos</h1>

        <CursosFilter handleSubmit={handleFilterChange} />

        <Table
          redirect={(e: any) => {
            redirect(e);
          }}
          list={false}
          data={data}
          dataCount={cursosCount}
          headers={headers}
          handleFilter={handleFilterTable}
          hideAudit={true}
          itemsOnLeft={4}
          showSelectList={true}
          handleExportExcel={handleExportExcel}
          orderMobile={true}
          orderOptions={options}
          handleCellSelect={handleCellSelect}
        />

        <RfUiModal
          title-modal={modalOkMessage}
          id-modal="modalOk"
          modal-type={modalOkType}
          onModalClose={(e: any) => {
            closeModalOk();
          }}
        ></RfUiModal>

        <RfUiModal
          title-modal={
            'Está modificando el estado de un curso que estaba cerrado. El estado Cerrado no se actualiza en proceso nocturno. Permanecerá activo hasta que se cierre manualmente'
          }
          id-modal="modalCursoCerrado"
          modal-type={modalCerradoType}
          onModalClose={(e: any) => {
            closeModalCerrado();
          }}
          onConfirm={() => {
            confirmModalCerrado();
          }}
          modalConfirmText="Aceptar"
        ></RfUiModal>
        <RfUiModal
          title-modal={msgSubmit}
          modalConfirmText="Aceptar"
          id-modal="modalDraft"
          modal-type={modalDraftType}
          onModalClose={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
          onConfirm={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
        ></RfUiModal>
      </div>
    </div>
  );
};

export default Courses;
